import Vue from "vue";
import App from "./app.vue";
import router from "@/router";
import vuetify from "@/plugins/vuetify";
import "@/plugins/axios";
import "@/plugins/signature";
import "@/plugins/filters";


import AxiosInterceptor from "@/plugins/axios-interceptor";
import store from "@/vuex/store";
new AxiosInterceptor();

Vue.config.productionTip = false;

new Vue({
  el: "#app",
  router,
  vuetify,
  store,
  render: (h) => h(App),
});

